import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import c20Ratings from "../../../../src/data/articles/cube-prospective-commander-2020/c20-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  c20Ratings,
  ProspectiveIntro,
  React
};